import {ReactNode} from 'react';
import {EvObjectsLoadingSwitchModel} from './ev-loading-list.model';

interface Props<T> {
  query: EvObjectsLoadingSwitchModel<T>;
  children: {
    success: ReactNode;
    error?: ReactNode;
    loading?: ReactNode;
  }
}

export function EvLoadingSwitch<T>(props: Props<T>): ReactNode {
  switch (props.query.status) {
    case 'success':
      return props.children.success;
    case 'error':
      return props.children.error;
    default:
      return props.children.loading;
  }
}
